var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSmallThumbnailsViewIcon = function SvgSmallThumbnailsViewIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6 9.9v4.2c0 .336.264.6.6.6h3.6c.336 0 .6-.264.6-.6V9.9c0-.336-.264-.6-.6-.6h-3.6c-.336 0-.6.264-.6.6Zm-6 4.2V9.9c0-.336.264-.6.6-.6h3.6c.336 0 .6.264.6.6v4.2c0 .336-.264.6-.6.6h-3.6a.594.594 0 0 1-.6-.6ZM7.8 9.3H4.2c-.336 0-.6.264-.6.6v4.2c0 .336.264.6.6.6h3.6c.336 0 .6-.264.6-.6V9.9c0-.336-.264-.6-.6-.6Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }))));
};

export default SvgSmallThumbnailsViewIcon;